import { OwcTypography } from "@one/react";
import PropTypes from "prop-types";
import { valueOrEmpty } from "../../../../utils/helpers/text";

const ApprovalStatus = ({ approvalStatus }) => {
  return (
    <div>
      <OwcTypography variant="caption">Approval Status</OwcTypography>
      <OwcTypography variant="button">
        {valueOrEmpty(approvalStatus, false, "-")}
      </OwcTypography>
    </div>
  );
};

ApprovalStatus.propTypes = {
  approvalStatus: PropTypes.string
};

export default ApprovalStatus;
